const getDashboardTableElements = (pluggableAttributes) => {
  const getDefaultLayout = (hideAdditionalColumns) => ({
    entityTableId: "dashboards",
    defaultPageSize: 20,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: hideAdditionalColumns ? ["title", "description", "summary"] : ["title", "description", "summary", "favorite", ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) || []],
    defaultColumnOrder: [
      "title",
      "summary",
      "description",
      "owner",
      "_entity_source.source",
      "created_at",
      "last_updated_at",
      ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) || [],
      "favorite"
    ]
  });
  const additionalAttributes = [...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributes) || []];
  return {
    getDefaultLayout,
    additionalAttributes
  };
};
export default getDashboardTableElements;
